/**
 * Pure numeric constants for `CropOverlay`'s move/rotate badge sizing, split out from
 * `crop-overlay.tsx` so `floating-canvas-chrome-bounds.ts` can reuse them (to compute the
 * photo-rotate dial's worst-case screen reach for floating toolbar/slider placement) without
 * pulling `crop-overlay.tsx`'s own import chain — which drags in the WASM geometry boundary
 * (`import.meta.env`) and breaks under Jest's CJS transform — into a plain `lib/` utility.
 */

/** Center move badge — default/floor on-screen size (px), regardless of canvas zoom. */
export const MOVE_BADGE_DEFAULT_SCREEN_SIZE = 40

/** Rotate badge — sized relative to the move badge (24px badge / 40px move badge in the design). */
export const ROTATE_BADGE_SIZE_RATIO = 24 / 40

/** Connecting line length (edge to edge), relative to the move badge's screen size. */
export const ROTATE_LINE_LENGTH_RATIO = 1.67

/** Direction of the connecting line at shape rotation 0 — up and to the right (screen space). */
export const ROTATE_BASE_ANGLE_DEG = -45

/** Resize handle radius (screen px), regardless of canvas zoom. */
export const CROP_RESIZE_HANDLE_SCREEN_RADIUS = 5

/** Breathing room (screen px) kept between the rotate badge and a corner resize handle when the
 *  dial's reach is extended to clear it — see the `cornerReachDoc` block in
 *  `crop-overlay/helpers/badge-layout.ts`. */
export const ROTATE_BADGE_CORNER_CLEARANCE_PX = 8
